module.exports = __webpack_public_path__ + "f0d3779b814004129d8522d52270d949.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/wanzhuan/five/five-bg.jpg
// module id = 458
// module chunks = 0